import type { TinValidationResult } from '@1trading/ts-common/tin';

import { reportInvalidIdentifier } from './identifier';

type ValidateTin = (countryAlpha2: string, value?: string) => TinValidationResult;

type GetPreviousTaxIdForCountryArgs = {
  country: string;
  /** TINs already entered against the other tax residences */
  otherTaxIds: string[];
  previousTaxId?: string;
  validate: ValidateTin;
};

type ReportTaxIdentificationNumberFormatErrorArgs = {
  country: string;
  taxId: string;
  validate: ValidateTin;
};

/**
 * The TIN to offer for a chosen country of tax residence, or `''`. The TIN given before tax residency was collected
 * has no country, so it is offered only where it matches the country's validated format and no other residence holds it.
 */
export const getPreviousTaxIdForCountry = ({ country, otherTaxIds, previousTaxId, validate }: GetPreviousTaxIdForCountryArgs) => {
  if (!previousTaxId || otherTaxIds.includes(previousTaxId)) return '';

  const { coverage, outcome } = validate(country, previousTaxId);

  return outcome === 'VALID' && coverage === 'validated' ? previousTaxId : '';
};

export const reportTaxIdentificationNumberFormatError = ({ country, taxId, validate }: ReportTaxIdentificationNumberFormatErrorArgs) => {
  if (!country || validate(country, taxId).outcome !== 'INVALID') return;

  reportInvalidIdentifier('TIN_VALIDATION_FAILED', { country, identifier: taxId });
};
